import { useQuery } from 'react-query';
import { usePublicApiClient } from '../usePublicApiClient';
import { ContentfulThemeApiClient } from '@jbhi-fi/apis/src/contentfulThemeApi';
import { ContentfulSearchContent } from '@jbhi-fi/apis/src/contentful/types';

export type UseContentfulSearchContentResult = {
  isLoading?: boolean;
  searchContentResults?: Array<ContentfulSearchContent>;
};

export const useContentfulSearchContent = ({
  contentfulThemeApiClient: contentfulThemeApiClientProp,
  searchTerm,
}: {
  contentfulThemeApiClient?: ContentfulThemeApiClient;
  searchTerm: { term: string };
}): UseContentfulSearchContentResult => {
  const { contentfulThemeApiClient: contentfulThemeApiClientContext } = usePublicApiClient();
  const contentfulThemeApiClient = contentfulThemeApiClientProp || contentfulThemeApiClientContext;
  if (!contentfulThemeApiClient) {
    throw new Error(
      'useContentfulSearchContent must be provided with a contentfulThemeApiClient via PublicApiClientProvider or props'
    );
  }
  const keywords = searchTerm?.term;
  const { data, isLoading } = useQuery({
    enabled: Boolean(contentfulThemeApiClient),
    queryKey: ['useContentfulSearchContent', keywords],
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    queryFn: () =>
      contentfulThemeApiClient?.getEntries<ContentfulSearchContent>({
        content_type: 'searchContent',
        include: '6',
        cache: 'medium',
        order: 'fields.order',
        'fields.keywords[match]': keywords,
      }),
  });

  const results = data?.data?.items || [];

  return {
    isLoading,
    searchContentResults: results,
  };
};
